import {Checkbox, FormControlLabel, Grid, GridProps, Typography, TypographyProps,} from "@mui/material";
import {Box, styled} from "@mui/system";

export const GridBlock = styled((props: GridProps) => (
  <Grid container item flexDirection={"column"} direction="row" {...props} />
))(({ theme }) => ({
  padding: "clamp(50px, 7.8125vw, 150px)",
  width: "100%",
  height: "460px",
  alignItems: "center",
  justifyContent: "center",
}));

export const Headline = styled((props: TypographyProps) => (
  <Typography variant="h4" color="primary" {...props} />
))(({ theme }) => ({
  width: "100%",
  fontSize: "clamp(40px, 3.33vw, 64px)",
  fontWeight: 600,
  marginBottom: "clamp(40px, 7.916vw, 15px)",
}));

export const InputBox = styled("div")(({ theme }) => ({
  height: "140px",
}));

export const InputUpperLabel = (props: any) => (
  <Typography variant="h4" sx={{ mb: "clamp(12px, 1.04vw, 20px)" }}>
    {props.children}
  </Typography>
);

export const InputHelperText = (props: any) => (
  <Typography variant="h5" sx={{ textAlign: "end" }}>
    {props.children}
  </Typography>
);

export const FormCheckBox = (props: any) => (
  <Box
    sx={{
      width: "240px",
      mb: "clamp(20px, 1.5625vw, 30px)",
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    {props.children}
  </Box>
);

// CheckBox
const MainCheckBox = (props: any) => (
  <Checkbox
    sx={{
      borderRadius: "5px",
      color: "primary.main",
      "& .MuiSvgIcon-root": {
        fontSize: "clamp(24px, 1.5625vw, 30px)",
      },
    }}
  />
);
export const StyledCheckBox = (props: any) => (
  <FormControlLabel
    control={<MainCheckBox />}
    label="Запомнить меня"
    sx={{
      "& .MuiFormControlLabel-label": {
        color: "#666666",
        fontSize: "24px",
      },
    }}
  />
);


